import React, { useContext, useState } from "react";
import { DropDownOptions, IProjectModel, ThemeTypes } from "../../models/SharedModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faFlag,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { pastDays, text_convert_lower } from "../../helpers/GenericHelpers";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import { ThemeContext } from "../../models/ThemeContext";
import historyDark from '../../images/darkLeftBarIcons/historyDark.png'
import { ProjectStatus } from "../../models/ProjectModel";
import documentAIService from "../../projects/document_ai/documentAIService";

interface IProjectCardProps {
  project: IProjectModel;
  handleClick: (project: IProjectModel) => void;
  optionsDropdown: string;
  toggleOptionsDropdown: (e: any, value: string) => void;
  toggleAddWorkSpaceModal: Function;
  dropDownSelection?: (type: DropDownOptions, project: IProjectModel) => void;
  workSpaceData?: any
  setSelectedProject: Function;
  get_project_list?: Function;
}

const ProjectCard = (props: IProjectCardProps) => {
  const {
    project,
    handleClick,
    optionsDropdown,
    toggleOptionsDropdown,
    dropDownSelection,
    setSelectedProject,
    get_project_list
  } = props;

  const service = new documentAIService();

  const { themeName } = useContext(ThemeContext);
  const [flagDropdown, setFlagDropdown] = useState('')

  // helpers
  const momentFormat = "MM/DD/YY hh:mm A";

  const toggleFlagDropdown = (e: any, value: string) => {
    e?.stopPropagation();
    setFlagDropdown((prev) => (prev === value ? "" : value));
  }

  const displayFlagsItems = () => {
    const keys = project?.flag_count?.flag_counts ? Object.keys(project?.flag_count?.flag_counts) : []
    return keys?.map(each => <DropdownItem className={each?.toLocaleLowerCase()}>{each}: {project?.flag_count?.flag_counts?.[each]}</DropdownItem>)
  }

  const selectProjectAction = () => {
    props.toggleAddWorkSpaceModal();
    setSelectedProject(project)
  }

  const removeSolution = (project_id:string) =>{
    const payload = {
      'project_id': project_id,
      'chat_history_op':"remove_project"
    }
    service.save_chat_history(payload).then((response:any)=>{
      console.log(response?.data)
      get_project_list && get_project_list();
      toggleRemoveModal()
    }).catch((error:any)=>{
      console.log(error)
    })
  }

  const  [removeModal, setRemoveModal] =useState<boolean>(false);
  const toggleRemoveModal = () =>{
    setRemoveModal((prev) => {
      return !prev;
    });
  }
  return (
    <>
        <>
          <div onClick={() => handleClick && handleClick(project)}
            className={`proj-main-card ${project?.project_status?.toLocaleLowerCase()} ${project?.flag_count > 0 ? 'flagged' : ''}`}
          >
            {/* Title row */}
            <div className="proj-title-main">
              <div className="project-left">
                <div className="proj-name">{project?.project_name || "--"}</div>
                <div className={`proj-type ${project?.project_type}`}>
                  {text_convert_lower(project?.project_type) || "--"}
                </div>
              </div>
              <div className="proj-menu">
                <div className="proj-options" onClick={(e: any) => toggleOptionsDropdown(e, project?.project_id)}>
                  <Dropdown
                    // Todo: change its project id
                    isOpen={optionsDropdown === project?.project_id}
                    toggle={(e: any) => toggleOptionsDropdown(e, project?.project_id)}
                  >
                    <DropdownToggle>
                        <FontAwesomeIcon icon={faEllipsisVertical} style={{ color: `${themeName === ThemeTypes?.BLUE_THEME ? 'black' : 'white'}`  }}/>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() =>
                          dropDownSelection &&
                          dropDownSelection(DropDownOptions.VIEW_LOGS, project)
                        }
                      >
                        View Log
                      </DropdownItem>
                      {[ProjectStatus.PRODUCTION].includes(project?.project_status as ProjectStatus) ?  <DropdownItem
                        onClick={() =>
                          dropDownSelection &&
                          dropDownSelection(DropDownOptions.NEW_VERSION, project)
                        }
                      >
                        Create Version
                      </DropdownItem> : null}
                      {/* {[ProjectStatus.DRAFT].includes(project?.project_status as ProjectStatus) ? <DropdownItem
                        onClick={() => selectProjectAction()}
                      >
                        Add to WorkSpace
                      </DropdownItem> : null} */}
                      <DropdownItem 
                              onClick={(e:any) => toggleRemoveModal()} 
                              >
                              Remove Solution
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
                {/* <div className="proj-version">v{project?.version || 1.0}</div> */}
              </div>
            </div>
            <div className="proj-info">
              {project?.project_status === 'draft' ?
                <div className="proj-api">
                  <div className="proj-info-value">OpenAI</div>
                  <div className="proj-info-title">MODELS</div>
                </div> : <div className="proj-api">
                  <div className="proj-info-value">{project?.apiCount || 0}</div>
                  <div className="proj-info-title">APIs DEPLOYED</div>
                </div>
              }
              {/* <div className="split"></div> */}
              <div className="proj-data-elem">
                <div className="proj-info-value">{project?.no_of_elements || 0}</div>
                <div className="proj-info-title">DATA ELEMENTS</div>
              </div>
              <div className="flags">
                <div className="proj-info-value">{project?.flag_count?.total_flag_count ?? 0}</div>
                <div className="proj-info-title">Flags</div>
              </div>
            </div>
            <div className="pro-details">
              <div className="proj-view-log"
                onClick={e => {
                  e?.stopPropagation();
                  dropDownSelection &&
                    dropDownSelection(DropDownOptions.VIEW_LOGS, project)
                }}>VIEW LOG
              </div>
              <div className="right">
                <div className="version">v{project?.version || 1.0}</div>
                <img src={historyDark} />
                <div className="days">{pastDays(project?.modified_date)}</div>
              </div>
            </div>
          </div>
        </>
        <Modal
          className={`project-modal conform-modal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
          isOpen={removeModal}
          toggle={toggleRemoveModal}
        >
            <ModalHeader toggle={toggleRemoveModal}>
              Do you want to delete ?
            </ModalHeader> 
            <ModalBody>
            <div className="btns">
              <Button className="cancel" onClick={() => toggleRemoveModal()}>
                No
              </Button>
              <Button className="submit attr-submit" 
                onClick={(e:any) => removeSolution(project?.project_id)} 
              >
                Yes
              </Button>
          </div>
            </ModalBody>
        </Modal>
    </>
  );
};

export default ProjectCard;

// {themeName === ThemeTypes?.BLUE_THEME ?
//   <div onClick={() => handleClick && handleClick(project)}
//     className={`proj-main-card ${project?.project_status?.toLocaleLowerCase()} ${project?.flag_count > 0 ? 'flagged' : ''}`}
//   >
//     {/* Title row */}
//     <div className="proj-title-main">
//       <div className="project-left">
//         <div className="proj-name">{project?.project_name || "--"}</div>
//         <div className={`proj-type ${project?.project_type}`}>
//           {text_convert_lower(project?.project_type) || "--"}
//         </div>
//       </div>
//       <div className="proj-menu">
//         <div className="proj-options">
//           <Dropdown
//             // Todo: change its project id
//             isOpen={optionsDropdown === project?.project_id}
//             toggle={(e: any) => toggleOptionsDropdown(e, project?.project_id)}
//           >
//             <DropdownToggle>
//               <FontAwesomeIcon icon={faEllipsisVertical} />
//             </DropdownToggle>
//             <DropdownMenu>
//               <DropdownItem
//                 onClick={() =>
//                   dropDownSelection &&
//                   dropDownSelection(DropDownOptions.VIEW_LOGS, project)
//                 }
//               >
//                 View Log
//               </DropdownItem>
//              {[ProjectStatus.PRODUCTION].includes(project?.project_status as ProjectStatus) ? <DropdownItem
//                 onClick={() =>
//                   dropDownSelection &&
//                   dropDownSelection(DropDownOptions.NEW_VERSION, project)
//                 }
//               >
//                 Create Version
//               </DropdownItem> : null}
//               {[ProjectStatus.DRAFT].includes(project?.project_status as ProjectStatus) ? <DropdownItem
//                 onClick={() => selectProjectAction()}
//               >
//                 Add to WorkSpace
//               </DropdownItem> : null}
//             </DropdownMenu>
//           </Dropdown>
//         </div>
//         <div className="proj-version">v{project?.version || 1.0}</div>
//       </div>
//     </div>

//     {/* info */}
//     <div className="proj-info">
//       {project?.project_status === 'draft' ?
//         <div className="proj-api">
//           <div className="proj-info-title">MODELS</div>
//           <div className="proj-info-value">OpenAI</div>
//         </div> : <div className="proj-api">
//           <div className="proj-info-title">APIs DEPLOYED</div>
//           <div className="proj-info-value">{project?.apiCount || 0}</div>
//         </div>
//       }
//       <div className="split"></div>
//       <div className="proj-data-elem">
//         <div className="proj-info-title">DATA ELEMENTS</div>
//         <div className="proj-info-value">{project?.no_of_elements || 0}</div>
//       </div>
//     </div>

//     {/* dates and flags */}
//     <div className="proj-dates-main">
//       <div className="proj-dates">
//         {project?.project_status === 'draft' ? <></> :
//           <div className="proj-item prod">
//             <div className="proj-info-title">PRODUCTION DATE</div>
//             <div className="proj-info-value">
//               {moment(project?.production_date ?? new Date()).format(
//                 momentFormat
//               )}
//             </div>
//           </div>
//         }
//         <div className="proj-item issued">
//           <div className="proj-info-title">LAST USED</div>
//           <div className="proj-info-value">
//             {moment(project?.modified_date ?? new Date()).format(momentFormat)}
//           </div>
//         </div>
//       </div>
//       <div className="proj-bottom-right">
//         <Dropdown
//           isOpen={flagDropdown === project?.project_id}
//           toggle={(e: any) => project?.flag_count?.total_flag_count > 0 && toggleFlagDropdown(e, project?.project_id)}
//         >
//           <DropdownToggle>
//             <div className="proj-flag">
//               <FontAwesomeIcon icon={faFlag} />
//               <div className="flag-value">{project?.flag_count?.total_flag_count ?? 0}</div>
//             </div>
//           </DropdownToggle>
//           <DropdownMenu>{displayFlagsItems()}</DropdownMenu>
//         </Dropdown>
//         <div className="proj-view-log"
//           onClick={e => {
//             e?.stopPropagation();
//             dropDownSelection &&
//               dropDownSelection(DropDownOptions.VIEW_LOGS, project)
//           }}>VIEW LOG</div>
//       </div>
//     </div>
//   </div> 
//   :
